import {
  createRouter,
  createWebHistory
} from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Landing from "../views/Landing.vue";
import AboutUs from "../views/Aboutus.vue";
import Advisory from "../views/Advisory.vue";
import Platfrom from "../views/Platfrom.vue";
import Blogs from "../views/Blog.vue";
import Solution from "../views/Solution.vue";
import Contact from "../views/ContactUs.vue";
import TitleSetting from "../views/TitleSetting.vue";

const routes = [{
    path: "/",
    name: "/",
    redirect: "/signin",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/landing",
    name: "Landing",
    component: Landing,
  },
  {
    path: "/aboutus",
    name: "AboutUs",
    component: AboutUs,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/advisory",
    name: "Advisory",
    component: Advisory,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/platform",
    name: "Platform",
    component: Platfrom,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/blogs",
    name: "Blogs",
    component: Blogs,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/solution",
    name: "Solution",
    component: Solution,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
  {
    path: "/setting",
    name: "Setting",
    component: TitleSetting,
    meta: {
      requiresAuth: true
    }, // Only accessible if logged in
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Define a global navigation guard
router.beforeEach((to, from, next) => {
  // Assuming `isAuthenticated` is a boolean that you check for login status.
  // Replace `isAuthenticated` with your actual logic to check login status, such as a Vuex state or local storage check.
  const isAuthenticated = !!localStorage.getItem('access_token'); // Example: Check if an auth token exists

  if (to.meta.requiresAuth && !isAuthenticated) {
    // Redirect to the login page if not authenticated
    next({
      name: '/'
    }); // Adjust the route name as per your login page's route name
  } else {
    // Proceed as normal
    next();
  }
});
export default router;